import React from 'react'
import { connect } from 'react-redux'
import {CatoroSpinner} from '../CatoroSpinner'
import {getProfileId, fetchAnotherUser} from '../../actions/actions'
import Profile from './Profile'
import DisplayError from '../DisplayError'

class ProfileShow extends React.Component {
    state = {
        notFound: false
    }

    componentDidMount(){
        // if using HashRouter:
        // const path = window.location.hash.replace("#/profile/", "")
        
        const path = window.location.pathname.replace("/profile/", "")

        // check if base64 encoded
        if (path.match(/^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/)) {

            const profileId = getProfileId(path)

            if (profileId.includes("391")) {
                this.props.fetchAnotherUser(profileId.replace("+391+", ""))
            } else {
                this.setState({
                    notFound: true
                })
            }
    
        } else {
            this.setState({
                notFound: true
            })
        }
        
    }
    
    render(){
        if (this.props.error || this.state.notFound) {
            // console.log(this.props.error_msg)
            return <DisplayError errorMsg={this.props.error_msg} />
        } 
        else if (!this.props.anotherUser) {
            return (
                <CatoroSpinner/>
            )
        } else if (this.props.anotherUser) {
            return <Profile myAccount={false}/>  
        }  else if (this.props.anotherUser.id === this.props.user.id) {
            return <Profile myAccount={true}/>  
        }
    }

}

const msp = state => {
	return {
        isLoggedIn: state.users.isLoggedIn,
        user: state.users.user,
        anotherUser: state.users.anotherUser,
        error: state.users.error,
        error_msg: state.users.error_msg,
        // userTables: state.users.userTables,
        // table: state.cuppings.table
	}
  };
  
  export default connect(msp, {
    fetchAnotherUser,
  })(ProfileShow)